/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Origin_PlaceholderInputs */

const en_search_origin_placeholder = /** @type {(inputs: Search_Origin_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search origin...`)
};

const es_search_origin_placeholder = /** @type {(inputs: Search_Origin_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar origen...`)
};

/**
* | output |
* | --- |
* | "Search origin..." |
*
* @param {Search_Origin_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_origin_placeholder = /** @type {((inputs?: Search_Origin_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Origin_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_origin_placeholder(inputs)
	return es_search_origin_placeholder(inputs)
});